export default {"src":"/planos/_next/static/media/equifax-graphic-analysis.e30c79c8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};